import { useQuery, useQueryClient } from "@tanstack/react-query";

import { TenantListRequest, getRanaApiV1 } from "@nens/rana/api-v1";

import { createUpdateForQueries } from "./hooks/create-updater-for-queries";
import { QueryListReturn } from "./types/query-return";
import { fetchAllPages } from "./utils/fetch-all-pages";

// Single

const getTenantQuery = (isDisabled?: boolean) => {
  return getRanaApiV1().getQueryOptions({
    queryKey: ["tenant", "detail"],
    queryFn: async () => getRanaApiV1().TenantsApi.tenantRetrieve({}),
    enabled: !isDisabled,
  });
};

export const useTenantQuery = (isDisabled?: boolean) => {
  return useQuery(getTenantQuery(isDisabled));
};

// LIST

const TENANT_LIST_KEY_BASE = ["tenant", "list"] as const;

const getTenantListPageQuery = (args?: TenantListRequest) => {
  return getRanaApiV1().getQueryOptions({
    ignoreTenant: true,
    queryKey: [...TENANT_LIST_KEY_BASE, args],
    queryFn: async () => getRanaApiV1().TenantsApi.tenantList(args),
  });
};

export const useTenantListPageQuery = (args?: TenantListRequest) => {
  return useQuery(getTenantListPageQuery(args));
};

const getTenantAllQuery = () => {
  return getRanaApiV1().getQueryOptions({
    queryKey: TENANT_LIST_KEY_BASE,
    queryFn: async () => {
      return fetchAllPages(getRanaApiV1().TenantsApi.tenantList);
    },
  });
};

export const useTenantAllQuery = () => {
  return useQuery(getTenantAllQuery());
};

export const useUpdateTenantQueries = () => {
  const queryClient = useQueryClient();
  return createUpdateForQueries<QueryListReturn<typeof getTenantListPageQuery>>(queryClient, {
    getSingleQueryKey: () => getTenantQuery().queryKey,
    getListQueryKey: () => TENANT_LIST_KEY_BASE,
  });
};

export const useInvalidateTenantListQuery = () => {
  const queryClient = useQueryClient();
  return () => {
    queryClient.invalidateQueries({
      queryKey: TENANT_LIST_KEY_BASE,
      refetchType: "all",
    });
  };
};
